import { render, staticRenderFns } from "./RecordTagManager.vue?vue&type=template&id=3db25b7e&scoped=true&"
import script from "./RecordTagManager.vue?vue&type=script&lang=js&"
export * from "./RecordTagManager.vue?vue&type=script&lang=js&"
import style0 from "./RecordTagManager.vue?vue&type=style&index=0&id=3db25b7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db25b7e",
  null
  
)

export default component.exports